/**
 * 放送時刻とクライアントの時計を合わせるための計算（要件定義 3.2）。
 *
 * 端末の時計はずれていることがあるので、
 * API が返す serverTime との差分を持っておき、放送位置はサーバー時刻基準で求める。
 */

/** 放送位置から何秒ずれたら「放送中の位置に戻る」を出すか（要件定義 3.4） */
export const DRIFT_TOLERANCE_SECONDS = 5

/** サーバー時刻とクライアント時刻の差（ミリ秒）。クライアントに足すとサーバー時刻になる */
export const computeClockOffset = (serverTime: string, clientNowMs: number): number => {
  const server = Date.parse(serverTime)
  if (!Number.isFinite(server)) return 0
  return server - clientNowMs
}

/**
 * 放送開始からの経過秒。これが動画の再生開始位置になる。
 *
 * 番組枠が動画の尺より長い場合（在庫が少なく尺が余る場合）は
 * 尺を超えないところで止める。
 */
export const programOffsetSeconds = (
  startAt: string,
  nowMs: number,
  durationSeconds: number,
): number => {
  const start = Date.parse(startAt)
  if (!Number.isFinite(start)) return 0
  const elapsed = Math.floor((nowMs - start) / 1000)
  return Math.max(0, Math.min(elapsed, Math.max(0, durationSeconds)))
}

/** その時刻が番組の放送時間内か */
export const isWithinProgram = (startAt: string, endAt: string, nowMs: number): boolean => {
  const start = Date.parse(startAt)
  const end = Date.parse(endAt)
  return Number.isFinite(start) && Number.isFinite(end) && nowMs >= start && nowMs < end
}

/** 放送位置と実際の再生位置のずれ（秒）。正なら再生が遅れている */
export const playbackDrift = (
  broadcastOffsetSeconds: number,
  playerCurrentSeconds: number,
): number => broadcastOffsetSeconds - playerCurrentSeconds

/** 「放送中の位置に戻る」を出すべきか */
export const isOffAirPosition = (drift: number, tolerance = DRIFT_TOLERANCE_SECONDS): boolean =>
  Math.abs(drift) > tolerance
